import UserAccount from './UserAccount';

const index = () => {
  return <UserAccount />;
};

export default index;
